<template>
  <tool-panel>
    <template v-slot:title>Document Tools</template>
    <tool-link
      v-if="capabilities.separateContentBlocks"
      :to="clausesRoute"
      icon="fa-file-code"
      label="Clauses"
    />
    <tool-link
      v-else
      to="/contentblocks"
      icon="fa-file-code"
      label="Content Blocks - Find re-usable content"
    />
    <tool-link
      v-if="capabilities.relatedContent && !!sharedoId"
      to="/related-content"
      icon="fa-paperclip"
      label="Related Content - Find related content"
    />
    <tool-link
      v-if="!!sharedoId"
      to="/finalize-document"
      icon="fa-check-circle"
      label="Finalise Document - Finalise the document"
    />
  </tool-panel>
</template>
<script>
import ToolPanel from "./ToolPanel.vue";
import ToolLink from "./ToolLink.vue";
import customProperties from "@/services/word/customPropertiesService";
import { FOR_DOCUMENT_AUTHORS } from "@/constants/contentBlockIncludes";

export default {
  components: { ToolPanel, ToolLink },
  data: function () {
    return {
      sharedoId: "",
    };
  },
  computed: {
    clausesRoute: function () {
      return {
        name: "ContentBlocks",
        params: { include: FOR_DOCUMENT_AUTHORS },
      };
    },
  },
  created: async function () {
    this.sharedoId = await customProperties.get("SharedoActivityId");
  },
};
</script>
